import { TransferGiftCardModal } from 'components/gift-card-modal/transfer-gift-card';
import { usePaymentCheckoutRedesignExperiment } from 'experiments/use-payment-checkout-redesign-experiment';
import { TransferGiftCardRedesign } from 'pages/cart/payment/order-payment/transfer-gift-card-redesign/transfer-gift-card-redesign';

export default function AddGiftCard() {
  const isPaymentRedesignEnabled = usePaymentCheckoutRedesignExperiment();

  return isPaymentRedesignEnabled ? <TransferGiftCardRedesign /> : <TransferGiftCardModal />;
}
